module.exports = __webpack_public_path__ + "img/career_select_01.f04431d7.png";